"use strict";

var _defineProperty = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/defineProperty");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _reactJss = require("react-jss");

var _default = (0, _reactJss.withStyles)(function (_ref) {
  var palette = _ref.palette,
      screens = _ref.screens;
  return {
    root: _defineProperty({
      backgroundColor: palette.gray,
      width: '100%',
      fontFamily: 'Open Sans',
      fontSize: 14,
      position: 'fixed',
      bottom: 0,
      padding: 16,
      zIndex: 999999,
      color: palette.white,
      textAlign: 'center',
      '&:empty': {
        padding: 0
      }
    }, screens.xs, {
      fontSize: 12,
      padding: 14
    })
  };
});

exports["default"] = _default;